export default __webpack_public_path__ + "b4ba02c25c342ec0e97a46b21e03bbb2.jpg";